import { useAppSelector } from 'store/hooks';
import { SettingSelectors } from 'store/Settings';
import { UserSelectors } from 'store/User';

export const useOrderCardDispaySettings = (props?: {
  ignoreDeviceSetting?: boolean;
}) => {
  const { ignoreDeviceSetting } = props ?? {};

  const interfaceSettingsFeatureFlag = useAppSelector(
    UserSelectors.selectInterfaceSettings,
  );

  const {
    shouldDisplayCustomerAddress: _shouldDisplayCustomerAddress,
    shouldDisplayCustomerName: _shouldDisplayCustomerName,
    shouldDisplayCustomerPhoneNumber: _shouldDisplayCustomerPhoneNumber,
    shouldDisplayNumberOfItems: _shouldDisplayNumberOfItems,
    shouldDisplayTotalOrderValue: _shouldDisplayTotalOrderValue,
  } = useAppSelector(SettingSelectors.selectListViewPreviewInterfaceSettings);

  return {
    shouldDisplayCustomerAddress:
      (_shouldDisplayCustomerAddress || ignoreDeviceSetting) &&
      interfaceSettingsFeatureFlag.list_view_preview.customer_address,

    shouldDisplayCustomerName:
      (_shouldDisplayCustomerName || ignoreDeviceSetting) &&
      interfaceSettingsFeatureFlag.list_view_preview.customer_name,

    shouldDisplayCustomerPhoneNumber:
      (_shouldDisplayCustomerPhoneNumber || ignoreDeviceSetting) &&
      interfaceSettingsFeatureFlag.list_view_preview.customer_phone_number,

    shouldDisplayNumberOfItems:
      (_shouldDisplayNumberOfItems || ignoreDeviceSetting) &&
      interfaceSettingsFeatureFlag.list_view_preview.number_of_items,

    shouldDisplayTotalOrderValue:
      (_shouldDisplayTotalOrderValue || ignoreDeviceSetting) &&
      interfaceSettingsFeatureFlag.list_view_preview.total_order_value,
  };
};
